/**
 * Placeholder artwork of the cards.
 *
 * Mirrors `techcraft/utilities/art.py`, so a card rendered by the server and
 * one appended by the frontend show the very same scene.
 */

/** Names of the scenes living in `static/assets/img/voxel`. */
export const VOXEL_SCENES = ["island", "machine", "crystals", "quarry", "portal", "crates"] as const;

/** Return the address of the scene belonging to `seed`. */
export function voxelArt(seed: number): string {
    const index = Number.isFinite(seed) ? Math.abs(Math.trunc(seed)) : 0;
    const name = VOXEL_SCENES[index % VOXEL_SCENES.length] ?? VOXEL_SCENES[0];

    return `/static/assets/img/voxel/${name}.svg`;
}
